/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_HeightInputs */

const en_us2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height`)
};

const pt_br2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura`)
};

const es_419_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatura`)
};

const pt_pt2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura`)
};

const fr_fr2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const de_de2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const it_it2_profile_row_height = /** @type {(inputs: Profile_Row_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza`)
};

/**
* | output |
* | --- |
* | "Height" |
*
* @param {Profile_Row_HeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_height = /** @type {((inputs?: Profile_Row_HeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_HeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_height(inputs)
	if (locale === "es-419") return es_419_profile_row_height(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_height(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_height(inputs)
	if (locale === "de-DE") return de_de2_profile_row_height(inputs)
	if (locale === "it-IT") return it_it2_profile_row_height(inputs)
	return en_us2_profile_row_height(inputs)
});
export { profile_row_height as "profile.row_height" }